var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Social Media Icon Square/Facebook"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Social Media Icon",
    x: 0.660156,
    width: 34.92,
    height: 34.9199,
    rx: 7.75999,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Facebook",
    d: "M19.54 26.1899V18.2256H22.3479L22.7683 15.1218H19.54V13.1401C19.54 12.2415 19.802 11.6291 21.1556 11.6291L22.8819 11.6283V8.85227C22.5833 8.81451 21.5585 8.72998 20.3664 8.72998C17.8774 8.72998 16.1733 10.1764 16.1733 12.8328V15.1218H13.3583V18.2256H16.1733V26.1899H19.54V26.1899Z",
    fill: "#141619"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.a8a7d2e505bc8ae8d157badd30b40184.svg";
export { ForwardRef as ReactComponent };